<template>
  <i v-if="isRelevant" class="tm-visual-scene-menu" :style="styleObj">
    <i class="-apply" title="Apply" @mouseup.left="$_apply">
      <i class="wticon wticon-v_v8" />
    </i>
    <i class="-cancel" title="Cancel" @mouseup.left="$_cancel">
      <i class="wticon wticon-close_x" />
    </i>
  </i>
</template>

<script>
import { TimePoint } from '../../api/grid';
import { mapState, mapActions, mapGetters } from 'vuex';
import tmBus from '../../api/tmBus';

export default {
  name: 'tm-visual-scene-menu',

  data() {
    return {
      point: new TimePoint(0, 0),
    };
  },

  computed: {
    ...mapState('timemachine', {
      sceneTrack: (state) => state.sceneEscort.sceneTrack,
    }),
    ...mapGetters('timemachine', ['isDndMode']),

    isRelevant() {
      return !!this.sceneTrack && !this.isDndMode;
    },

    styleObj() {
      return {
        transform: `translate3d(${this.$data.point.x + 5}px, ${
          this.$data.point.y - 5
        }px, 0)`,
      };
    },
  },

  watch: {
    'sceneTrack.rectangles'(value) {
      const first = value && value.length && value[0];
      if (first) {
        this.$data.point.assign(first.p1);
      }
    },
  },

  methods: {
    ...mapActions('timemachine', [
      'SCENE_EDIT_MODE_APPLY',
      'SCENE_EDIT_MODE_CANCEL',
    ]),

    $_apply(e) {
      e.stopPropagation(); // evading tmTimemachine::$_onDocumentMouseUp

      this.SCENE_EDIT_MODE_APPLY({ keepItSelected: true }).then(
        ({ sceneTrack }) => {
          tmBus.$emit('callbackApplySceneEdit', {
            e,
            asset: sceneTrack.data,
            analyticsData: { confirm: 'v', using: 'menu' },
          });
        }
      );
    },

    $_cancel(e) {
      e.stopPropagation();

      this.SCENE_EDIT_MODE_CANCEL().then(({ sceneTrack }) => {
        tmBus.$emit('callbackCancelSceneEdit', {
          analyticsData: { confirm: 'x', using: 'menu' },
        });
      });
    },
  },
};
</script>

<style lang="scss">
.tm-tracks > .tm-visual-scene-menu {
  position: absolute;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: var(--tm-zTrackItemMenu);

  transition: opacity 0.2s ease;

  > i {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    width: 30px;
    height: 30px;
  }

  > .-apply {
    background-color: $color-primary;
    color: #fff;
    &:hover {
      background-color: $color-blue-d;
    }
  }

  > .-cancel {
    color: $color-primary;
    &:hover {
      color: $color-blue-d;
    }
  }
}
</style>
